import { components } from 'react-select'
import { Box, ClickAwayListener } from '@mui/material'

const Control = ({ children, ...props }) => {
  const { menuIsOpen, onMenuClose, onMenuOpen } = props.selectProps;
  return (
    <components.Control {...props}>
      <ClickAwayListener
        mouseEvent='onMouseDown'
        onClickAway={() => {
          onMenuClose();
        }}
      >
        <Box
          onClick={() => {
            if (menuIsOpen) {
              onMenuClose();
            } else {
              onMenuOpen();
            }
          }}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexGrow: 1,
            minWidth: 0,
            gap: 7,
            cursor: 'pointer'
          }}
        >
          {children}
        </Box>
      </ClickAwayListener>
    </components.Control>
  );
}

export default Control
